<template>
    <vs-popup class="redemption-history-popup" title="Redemption History" :active.sync="popupRedemptionHistory.isOpen">
        <p class="mb-4 font-bold text-black" v-if="giftCardDetail && giftCardDetail.code">Gift card: {{formatGiftCardCode(giftCardDetail.code)}}</p>
        <div class="flex flex-wrap mb-4 font-bold text-black" v-if="giftCardDetail">
            <div class="w-1/4">
                <p>Amount: <span v-if="giftCardDetail.amount != null && giftCardDetail.amount != undefined">${{giftCardDetail.amount}}</span> <span v-else>N/A</span></p>
            </div>
            <div class="w-1/4">
                <p>Balance: <span v-if="giftCardDetail.balance != null && giftCardDetail.balance != undefined">${{giftCardDetail.balance}}</span> <span v-else>N/A</span></p>
            </div>
            <div class="w-1/4">
                <p>Status: {{getStatus(giftCardDetail.status)}}</p>
            </div>
        </div>
        <div class="h-full overflow-auto">
            <vs-table class="create-table" :data="historyData">
                <template slot="thead">
                    <vs-th class="w-1/12 text-center center-title">NO.</vs-th>
                    <vs-th class="w-2/12 text-center center-title">ORDER ID</vs-th>
                    <vs-th class="w-4/12 text-center center-title">CUSTOMER NAME</vs-th>
                    <vs-th class="w-3/12 text-center center-title">REDEMPTION AMOUNT</vs-th>
                    <vs-th class="w-2/12 text-center center-title">BALANCE</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="text-center border-left-custom border-top-custom">{{indextr + 1}}</vs-td>
                        <vs-td class="text-center border-left-custom border-top-custom text-primary" :data="tr.order_id">
                            <router-link :to="{path: '/go-pos/order-detail?id=' + tr.order_id}" :key="tr.order_id" target='_blank'>
                                <span>OD {{tr.order_id}}</span>
                            </router-link>
                        </vs-td>
                        <vs-td class="text-center border-left-custom border-top-custom">
                            <span v-if="tr.customer_name">{{tr.customer_name}}</span>
                            <span v-else>N/A</span>
                        </vs-td>
                        <vs-td class="text-center border-left-custom border-top-custom" :data="tr.data">{{getChangeBalance(tr.data)}}</vs-td>
                        <vs-td class="text-center border-left-custom border-top-custom" :data="tr.balance">${{tr.balance}}</vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vs-popup>
</template>

<script>
import moment from 'moment';
import {changeFormatHelper} from '../../helper/datetimeHelper';
export default {
    name: 'redemption-history',
    props: {
        popupRedemptionHistory: {
            type: Object,
            required: true
        },
        activeGiftCard: {
            type: Object
        }
    },
    data() {
        
        return {
            STATUS_NOT_SOLD_YET: 0,
            STATUS_SOLD: 1,
            STATUS_USED_UP: 2,
            STATUS_CANCELLED: 99,
            isOpenLoading: false
        }
    },
    watch: {
        activeGiftCard: {
            immediate: true,
            deep: true,
            handler() {
                if(this.activeGiftCard && this.activeGiftCard.id != null && this.activeGiftCard.id != undefined) {
                    if(!this.isOpenLoading) {
                        this.openLoadingInDiv();
                    }
                    this.$store.dispatch('serviceList/GET_GIFTCARD_DETAIL', { id: this.activeGiftCard.id }).then(() => {
                        this.closeLoading();
                    });
                } 
            }
        }
    },
    methods: {
        openLoadingInDiv(){
          this.$vs.loading({
            container: '#app',
            scale: 0.8
          })
          if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                      color: 'danger',
                      title: 'Notification',
                      text: 'Get gift card detail failed',
                      acceptText: 'OK'
                  })
              }
          }, 10000);
        },
        closeLoading() {
          this.$vs.loading.close('#app > .con-vs-loading');
          this.isOpenLoading = false;
        },
        getTime(date) {
            return moment(date).format('hh:mm A');
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
        formatGiftCardCode(code) {
            if(code != '') {
                let arr = code.split('');
                let result = '';
                for(let i = 0; i < arr.length; i++) {
                    if(i % 4 == 0) {
                        result = result + ' ' + arr[i];
                    } else {
                        result += arr[i];
                    }
                }
                return result;
            }
            return 'N/A';
        },
        getStatus(status) {
            if(status == this.STATUS_NOT_SOLD_YET) {
                return 'Not Sold Yet';
            } else if(status == this.STATUS_SOLD) {
                return 'Sold';
            } else if(status == this.STATUS_USED_UP) {
                return 'Used up';
            } else if(status == this.STATUS_CANCELLED) {
                return 'Cancelled';
            } else {
                return 'N/A';
            }
        },
        getChangeBalance(data) {
            if(data) {
                let json_data = JSON.parse(data);
                // console.log(json_data);
                if(json_data && json_data.balance_change < 0) {
                    return '-$' + json_data.balance_change*(-1);
                }
                // return json_data.balance_change;
            }
            return '$0';
        }
    },
    computed: {
        giftCardDetail() {
            return this.$store.getters['serviceList/giftCardDetail'];
        },
        // historyData() {
        //     return this.$store.getters['serviceList/giftCardDetail'] && this.$store.getters['serviceList/giftCardDetail'].history ?
        //      this.$store.getters['serviceList/giftCardDetail'].history.filter((history) => history.data) : this.$store.getters['serviceList/giftCardDetail'].history;
        // }
        historyData() {
            return this.$store.getters['serviceList/giftCardDetail'] && this.$store.getters['serviceList/giftCardDetail'].history ?
            this.$store.getters['serviceList/giftCardDetail'].history.filter((history) => ((history.type == 'used_up' || history.type == 'redemption') && history.data != null))
             : this.$store.getters['serviceList/giftCardDetail'].history;
        }
    }
}
</script>